<template>
    <div ref="cell"
        :class="cellClass"
        :style="cellStyle"
        @mouseenter="handleShowPopper"
        @mouseleave="handleClosePopper">
        <slot name="prefix"></slot>
        <Render v-if="renderType == 'render'"
            :data="data"
            :column="column"
            :index="node.nodeKey"
            :editing="editing"
            :cellEditing="cellEditing"
            :cellEditable="cellEditable"
            :node="node"
            :flatState="flatState"
            :render="column.render"></Render>
        <!-- depreciate, will be remove in the future-->
        <node-edit v-if="renderType === 'edit'"
            :row="data"
            :column="column"
            :index="node.nodeKey"
            :cellEditing="cellEditing"
            :cellEditable="cellEditable"
            :node="node"
            :flatState="flatState"></node-edit>
        <node-slot v-if="renderType === 'slot'"
            :row="data"
            :column="column"
            :index="node.nodeKey"
            :editing="editing"
            :cellEditing="cellEditing"
            :cellEditable="cellEditable"
            :node="node"
            :flatState="flatState"></node-slot>
        <span v-if="renderType == 'normal'"
            data-cls="cell-content">
            {{data[column.key]}}</span>
    </div>
</template>
<script>
import Tooltip from '../tooltip'
import Render from './render'
import AsyncValidator from 'async-validator';
import NodeEdit from './edit';
import NodeSlot from './slot';
import { getParentNodes } from './util'
import { getTextWidth } from '../../utils/assist';

var uid = 0
var cellPadding = void(0)

export default {
    name: "TreeTableCell",

    provide() {
        return { cell: this }
    },

    inject: ['treeRoot'],

    components: {
        Tooltip,
        Render,
        NodeEdit,
        NodeSlot,
    },

    props: {
        column: {
            type: Object,
        },
        data: {
            type: Object,
        },
        node: {
            type: Object,
        },
        validation: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            uid: uid++,
        }
    },

    computed: {
        prefixCls() {
            return 'ivu-tree-table'
        },
        cellClass() {
            return [
                this.prefixCls + '-cell',
                this.column.className || '',
                this.data.cellClassName && this.data.cellClassName[col.key] || '',
                {
                    [`${this.prefixCls}-cell-with-error`]: this.errors.length > 0,
                    [`${this.prefixCls}-cell-in-readonly`]: !this.cellEditing,
                    [`${this.prefixCls}-cell-ellipsis`]: this.column.ellipsis || this.column.tooltip || false,
                }
            ]
        },
        cellStyle() {
            return {
                width: this.column.width + 'px',
                'text-align': this.column.align
            }
        },
        renderType() {
            if (this.column.render) {
                return 'render'
            } else if (this.column.edit) {
                return 'edit'
            } else if (this.column.slot) {
                return 'slot'
            } else {
                return 'normal'
            }
        },
        showErrorTip() {
            return this.errors.length > 0
        },
        errors() {
            return this.validation.errors || []
        },
        errorMsg() {
            return this.errors.map(v => v.message).join(";")
        },
        decimalLimit() {
            if (this.column.options && this.column.options.props && this.column.options.props.decimalLimit) {
                return this.column.options.props.decimalLimit
            }

            return 2
        },
        flatState() {
            return this.treeRoot.flatState
        },
        editing() {
            return this.node._isEditing
        },
        canEdit() {
            var canEdit = this.column.canEdit

            if (typeof canEdit == "undefined") {
                // 自定义单元格默认可编辑
                return !!this.column.render || !!this.column.slot || !!this.column.edit
            }

            if (typeof canEdit == "function") {
                return canEdit({
                    row: this.data,
                    column: this.column,
                    index: this.node.nodeKey,
                    value: this.data[this.column.key],
                    node: this.node
                })
            }
        },
        cellEditing() {
            return !!(this.editing && this.canEdit)
        },
        cellEditable(){
            return !!(this.node._isHover && this.canEdit)
        }
    },

    methods: {
        editCellChange(key, val) {
            // 更新数据
            this.data[key] = val
        },
        handleShowPopper() {
            var $cell = this.$refs.cell

            // 错误提示框优先显示
            if (this.showErrorTip) {
                return this.treeRoot.handleShowPopper({
                    reference: $cell,
                    content: this.errorMsg,
                    width: getTextWidth(this.errorMsg, 12) + 24
                })
            }

            // 文本溢出tooltip
            if (this.column.tooltip) {
                const $content = $cell.querySelector("[data-cls=cell-content]")

                if ($content && $content.offsetWidth > ($cell.clientWidth - cellPadding * 2)) {
                    var text = this.data[this.column.key]

                    return this.treeRoot.handleShowPopper({
                        reference: $cell,
                        content: text,
                        width: getTextWidth(text, 12) + 24
                    })
                }
            }
        },
        handleClosePopper() {
            this.treeRoot.handleClosePopper()
        },
    },

    created() {
        // 末级向上汇总
        if (this.column.accUp && this.node.isEnd) {
            this.$watch(
                function() {
                    // 使用监听函数，是应为key值可能包含特殊字符
                    return this.data[this.column.key]
                },
                function(newVal, oldVal) {
                    var increment = parseFloat(newVal || 0) - parseFloat(oldVal || 0)

                    // 数值向上汇总
                    if (!isNaN(increment) && increment != 0) {
                        this.treeRoot.accUp(this.node, {
                            [this.column.key]: {
                                increment,
                                decimalLimit: this.decimalLimit
                            }
                        })
                        this.treeRoot.$emit("accUpChange", getParentNodes(this.node))
                    }
                })
        }
    },

    mounted() {
        // 获取cell padding
        if (cellPadding == void(0)) {
            cellPadding = parseFloat(window.getComputedStyle(this.$refs.cell).paddingLeft) || 0
        }
    },
}
</script>